import React from 'react';

import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {showRightSidebarAction, toggleLeftmenu} from '../../store/actions';
import ProfileMenu from '../CommonForBoth/TopbarDropdown/ProfileMenu';
import logo from '../../assets/images/logo.svg';
import {withTranslation} from 'react-i18next';
import NotificationDropdown from
  '../CommonForBoth/TopbarDropdown/NotificationDropdown';
import SwitchDealerDropdown from
  '../CommonForBoth/TopbarDropdown/SwitchDealerDropdown';
import {Badge} from 'reactstrap';
import {getLoggedInUser} from '../../helpers/fakebackend_helper';
import {DEALER_FLAG_NON_TEXTILE, DEALER_FLAG_TEXTILE} from '../Dealer/DealerConst';

const Header = (props) => {
  const authUser = getLoggedInUser();

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/" className="logo">
                <span className="logo-sm">
                  <img src={logo} alt="" height="20"/>
                </span>
                <span className="logo-lg">
                  <img src={logo} alt="" height="30"/>
                </span>
              </Link>
            </div>

            <div className="align-self-center ml-2">
              <Badge
                color="white"
                className="font-size-18 text-uppercase font-weight-bold">
                {process.env.REACT_APP_REALM}
              </Badge>
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 d-lg-none header-item
              waves-effect waves-light"
              data-toggle="collapse"
              onClick={() => {
                props.toggleLeftmenu(!props.leftMenu);
              }}
              data-target="#topnav-menu-content">
              <i className="fa fa-fw fa-bars"></i>
            </button>
          </div>

          <div className="d-flex">

            {['test', 'bimh', 'bbo'].includes(process.env.REACT_APP_REALM) && authUser.user.flags?.includes(DEALER_FLAG_NON_TEXTILE) ?
              <Link to={'/downloads/non-textile'} className="d-none d-lg-block">
                <button
                  type="button"
                  className="btn btn-sm header-item waves-effect waves-light
                  d-flex align-items-center">
                  <i className="mdi mdi-cloud-download font-size-16"></i>
                  <span className="font-size-13 ml-2">
                      Downloads Non-Textile
                  </span>
                </button>
              </Link> : ''
            }

            {['test', 'bimh', 'bbo'].includes(process.env.REACT_APP_REALM) && authUser.user.flags?.includes(DEALER_FLAG_TEXTILE) ?
              <Link to={'/downloads/textile'} className="d-none d-lg-block">
                <button
                  type="button"
                  className="btn btn-sm header-item waves-effect waves-light
                  d-flex align-items-center">
                  <i className="mdi mdi-cloud-download font-size-16"></i>
                  <span className="font-size-13 ml-2">
                      Downloads Textile
                  </span>
                </button>
              </Link> : ''
            }

            <SwitchDealerDropdown/>

            <NotificationDropdown/>

            <ProfileMenu/>

          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  const {layoutType, showRightSidebar, leftMenu} = state.Layout;
  return {layoutType, showRightSidebar, leftMenu};
};

export default connect(
    mapStatetoProps, {showRightSidebarAction, toggleLeftmenu},
)(withTranslation()(Header));


